import { render, staticRenderFns } from "./AddOrEditContactDialog.vue?vue&type=template&id=0580cd84&"
import script from "./AddOrEditContactDialog.vue?vue&type=script&lang=js&"
export * from "./AddOrEditContactDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditContactDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports